module.exports = __webpack_public_path__ + "img/ellipse.b2d09f16.png";